module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10034.0e8ecefd.jpg";